import React from "react";
// import { Typography, Row, Col } from "antd";
import {} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const TransportationPage = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <div className="w-full py-8 px-4 text-center text-white bg-gradient-to-b from-[#F00D0D] to-[#994F4F]">
        <h1 className="text-[32px] font-bold mb-2">
          {t("transportation.title")}
        </h1>
        <p className="text-[22px] font-bold">{t("transportation.subtitle")}</p>
      </div>
      <iframe
        name="oresframe"
        // marginWidth="1"
        // marginHeight="1"
        height="1000"
        width="100%"
        // scrolling="yes"
        style={{ border: "0" }}
        title="Transportation Booking"
        src="https://book.mylimobiz.com/v4/traversia"
      >
        {" "}
        Your browser does not support inline frames or is currently configured
        not to display inline frames.{" "}
      </iframe>
    </div>
  );
};

export default TransportationPage;
